export default "__VITE_ASSET__o5H4vg$Q__"